<div>
    <button mat-raised-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="runNow()" [disabled]="isRunning">{{ 'Integrations-RunNow' | translate: {Default: "Run Now"} }}</button>
    <span *ngIf="isRunning" class="running-now-text">{{ 'Integrations-RunningNow' | translate: {Default: "Running Now..."} }}</span>
</div>